export default __webpack_public_path__ + "static/media/fetch_pals_banner.c89678d3.jpg";